import axios from 'axios';
import { isEmpty } from 'lodash';

const ROOT = 'api/v1/studies';

const StudyApi = {
  populateStudyList() {
    return axios.get(`${ROOT}`);
  },
  retryCard(proxyNum, patientId, hideLoader = false) {
    return axios.post(`${ROOT}/patients/${patientId}/retry/${proxyNum}`, null, {
      hideLoader
    });
  },
  addPatient(data) {
    return axios.post(`${ROOT}/patients/${data.studySiteIdentifier}`, data, {
      hideLoader: true
    });
  },
  getEnrolledPatientsCountBySsus(studySitesIds) {
    return axios.post(`${ROOT}/enrolled-patients-count/by-study-sites`, studySitesIds);
  },
  getScreenFailedPatientsCountBySsus(studySitesIds) {
    return axios.post(`${ROOT}/screen-failed-patients-count/by-study-sites`, studySitesIds);
  },
  getListOfSites() {
    return axios.get(`${ROOT}/sites`);
  },
  populateNonCanceledStudyList() {
    return axios.get(`${ROOT}/non-canceled`);
  },
  populateStudyDetailsByIdentifier(data) {
    return axios.get(`${ROOT}/${data}`);
  },
  updateTravelFolderLink(studyId, data) {
    return axios.put(`${ROOT}/${studyId}/travel-folder-links`, data);
  },
  getProtocolsByStudyIdentifierWithIncompleteCheck(studyIdentifier) {
    return axios.get(`${ROOT}/${studyIdentifier}/protocols`);
  },
  getProtocolsByStudyIdAndStatus(studyIdentifier, status) {
    return axios.get(`${ROOT}/${studyIdentifier}/protocols?status=${status}`);
  },
  geWithdrawnPatientsCountBySsus(studySitesIds) {
    return axios.post(`${ROOT}/withdrawn-patients-count/by-study-sites`, studySitesIds);
  },
  saveItemGroupWithRows(data, formData) {
    if (isEmpty(data.patientEncounterFormIdentifier)) {
      return axios.post(`${ROOT}/patients/${data.ssuPatientId}/item-groups/logs/${data.itemGroupTemplateId}`, formData);
    }
    return axios.post(
      `${ROOT}/patients/${data.ssuPatientId}/encounter/item-groups/${data.patientEncounterFormIdentifier}`,
      formData
    );
  },
  updateContactNumber(data) {
    return axios.put(`${ROOT}/patients/${data.patientUniqueIdentifier}/contact-number`, data);
  },
  getPatientRelatedStudies(data) {
    return axios.get(`${ROOT}/patients/studies/${data}`);
  },
  isStudyGroupAssign(studyId) {
    return axios.get(`${ROOT}/${studyId}/is-group-assigns`);
  },
  getSiteDetails(data) {
    return axios.get(`${ROOT}/sites/${data}`);
  },
  addPatientStudy(data) {
    return axios.put(`${ROOT}/patients/${data.studySiteIdentifier}/assign-study`, data);
  },
  getPatientEncounterItemGroupsWithActualizedIcf(ssuPatientId, ssuPatientEncounterId) {
    return axios.post(
      `${ROOT}/patients/encounters?ssuPatientId=${ssuPatientId}&ssuPatientEncounterId=${ssuPatientEncounterId}`
    );
  },
  setIsPresentEpochs(studyIdentifier, isPresentEpochs) {
    return axios.put(`${ROOT}/${studyIdentifier}/toggle-present-epochs`, isPresentEpochs);
  },
  toggleSmsOptIn(studyIdentifier, smsOptIn) {
    return axios.patch(`${ROOT}/${studyIdentifier}/toggle-sms-opt-in/${smsOptIn}`);
  },
  toggleOnHold(studyIdentifier, onHold) {
    return axios.patch(`${ROOT}/${studyIdentifier}/toggle-on-hold/${onHold}`);
  },
  updatePatientReimbursementSelfSubmission(studyIdentifier, patientReimbursementSelfSubmission) {
    return axios.patch(
      `${ROOT}/${studyIdentifier}/patient-reimbursement-self-submission/${patientReimbursementSelfSubmission}`
    );
  },
  updateDigitalPatientPayment(studyIdentifier, digitalPatientPayment) {
    return axios.patch(`${ROOT}/${studyIdentifier}/digital-patient-payment/${digitalPatientPayment}`);
  },
  updateOptionalPatientSsn(studyIdentifier, optionalSsn) {
    return axios.patch(`${ROOT}/${studyIdentifier}/digital-patient-payment/optional-ssn/${optionalSsn}`);
  },
  updateStudyTier(studyId, updateTierRequest) {
    return axios.patch(`${ROOT}/${studyId}/tiers`, updateTierRequest);
  },
  getAllStudyTiers(studyId) {
    return axios.get(`${ROOT}/${studyId}/tiers`);
  },
  getStudyTypes(studyIdentifier) {
    return axios.get(`${ROOT}/${studyIdentifier}/types`);
  },
  updateStudyTypes(studyIdentifier, selectedStudyTypeIds) {
    return axios.put(`${ROOT}/${studyIdentifier}/types`, selectedStudyTypeIds);
  },
  updateCostPerMileage(studyIdentifier, costPerMileagePayload) {
    return axios.patch(`${ROOT}/${studyIdentifier}/cost-per-mileage`, costPerMileagePayload);
  },
  updatePmLead(studyId, request) {
    return axios.put(`${ROOT}/${studyId}/pm-leads`, request);
  },
  updatePmSpecialist(studyId, request) {
    return axios.put(`${ROOT}/${studyId}/pm-specialists`, request);
  },
  updateContractSpecialist(studyId, request) {
    return axios.put(`${ROOT}/${studyId}/contract-specialists`, request);
  }
};

export default StudyApi;
